import React from 'react'
import AdminUserInfo from './user-info/AdminUserInfo'
import AdminCoUserInfo from './user-info/AdminCoUserInfo'

const UserInfo = () => {
    let userdata = JSON.parse(localStorage.getItem("user"))

    return (
        <div className='passwordReset'>
            {userdata ?
                userdata.role === "ADMIN" ?
                    <AdminUserInfo />
                :
                userdata.role === "ADMIN-CO" ?
                    <AdminCoUserInfo />
                :
                    ''
            :
                ''
            }
            
        </div>
    )
}

export default UserInfo

